import { useCallback } from "react";
import { useUserModuleDispatch, USER_MODULE_ACTION } from "..";
import useHidePopup from "../../result-popup/hooks/use-hide-popup";

export function useReset() {

    const userDispatch = useUserModuleDispatch();
    const hidePopup = useHidePopup();

    return useCallback(() => {
        userDispatch({type: USER_MODULE_ACTION.RESET})
        hidePopup();
    }, [userDispatch, hidePopup]);
}
